<template>
    <div class="bg" v-show="show" style='z-index:2000'>
        <div class="box">
            <a href="javascript:;" class="close-icon"><img src="@/assets/images/red-icon.png" alt=""></a>
            <p class="info" :style="{'font-size': size + 'px','color': color}">{{content}}</p>
            <div class="close-tit" @click='closeDialog'>关 闭</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BrokenNet',
        props: {
            show: {
                type: Boolean,
                default: false
            },
            size: {
                type: Number,
                default: 20
            },
            color: {
                type: String,
                default: '#5d5759'
            },
            content: {
                type: String,
                default: '网络无效，请重试！'
            }
        },
        methods: {
            closeDialog() {
                this.$emit('update:show', false)
                this.$emit('close')
            },
            touchHandle(e) {
                e.stopPropagation();
                e.preventDefault();
            }
        },
        mounted() {
            window.document.querySelector('.bg').addEventListener('touchmove', this.touchHandle, false);
        }
    };
</script>

<style scoped>
    .bg {
        position: fixed;
        top:0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, .8);
    }
    .box {
        position: absolute;
        top:50%;
        left:50%;
        transform: translate(-50%,-50%);
        background-color: #ffffff;
        width: 556px;
        height: 388px;
        border-radius: 30px;
    }
    .close-icon {
        display: inline-block;
        width: 100%;
        text-align: center;
        margin: 40px 0;
    }
    .close-icon img {
        width: 80px;
    }
    .info {
        text-align: center;
        /*font-size: 40px;*/
        /*color: #5d5759;*/
        margin-bottom: 68px;
    }
    .close-tit {
        border-top:1px solid #dbdddf;
        height: 100px;
        line-height: 100px;
        text-align: center;
        font-size: 36px;
    }
</style>